"use client";

import React from "react";
import { FileCheck, Settings, Cpu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const services = [{
  title: "Registered Massage Therapy",
  description: "Expert RMT treatments delivered with clinical precision to alleviate chronic pain and accelerate therapeutic recovery through specialized techniques.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1653134/img/未命名的设计-1.png"
}, {
  title: "J",
  description: "A ",
  icon: Settings
}, {
  title: "Facials",
  description: "Professional facial treatments for deep cleansing, hydration, and glowing skin. Tailored skincare solutions in.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1653134/img/未命名的设计-2.png"
}, {
  title: "Acupuncture",
  description: "Targeted needle therapy designed to relieve pain and accelerate recovery for systemic physical vitality.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1653134/img/image-3.png"
}, {
  title: "Wellness Consultation",
  description: "Personalized health assessments and holistic planning to align your lifestyle with your long-term vitality goals.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1653134/img/wellness_consultation.png"
}];
export default function SolucoesEmSustentabilidadeEGestao() {
  return;
}